import {fetchApiClient} from "common/fetchApiClient";
import {API_URL} from "common/const";
import NewRider from "model/admin/NewRider";
import {AxiosError} from "axios";


interface CreateRidersResponse {
    riderIds: number[];
}

/**
 * Creates riders globally, with no competition context — this is NOT the same
 * as `addRiders`, which does `PUT /riders/{competitionCode}` to attach riders
 * (with a team and a value) to one competition.
 *
 * The endpoint is bulk-shaped and idempotent by name: submitting a name that
 * already resolves (as a preferred name or an existing synonym) returns the
 * existing rider id instead of creating a duplicate. Returned ids align by
 * index with the riders passed in.
 */
const createRiders = async (riders: NewRider[], token: string | undefined): Promise<number[]> => {
    const apiClient = fetchApiClient(token);

    // Blank optional inputs must be dropped rather than sent as "", otherwise
    // an untouched form field would overwrite the column with an empty string.
    const payload = riders.map(rider => ({
        name: rider.name?.trim(),
        country: rider.country?.trim() || undefined,
        img: rider.img?.trim() || undefined,
        link: rider.link?.trim() || undefined,
    }));

    return await apiClient.post<CreateRidersResponse>(`${API_URL}/riders`, {
        riders: payload
    }).then(response => {
        return response.data.riderIds;
    }).catch((error: AxiosError) => {
        // console.error, not the console.log every sibling api file uses — §4.4 of
        // CODE_REVIEW_FINDINGS.md flags that as a finding, and a new file may as
        // well start out right.
        console.error(`Error creating riders`, riders, error);
        throw error;
    });
}

export default createRiders;
